import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/PrimaryBox';
import DangerBox from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/DangerBox';
import MqttTableBroker from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/MqttTableBroker';
import MqttTableClient from 'components/Web_User_Interface/1440p_Series/Smarthome/MQTT/MqttTableClient';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Smarthome Menu // INSTAR MQTT Broker",
  "path": "/Web_User_Interface/1440p_Serie/Smarthome/MQTT/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Konfigurieren Sie den INSTAR MQTT-Broker - aktivieren Sie den Server oder wechseln Sie zu einem externen Broker. Sie können auch die Authentifizierung konfigurieren und Ihr persönliches SSL-Zertifikat hinzufügen.",
  "image": "./WebUI_1440p_SearchThumb_Smarthome_MQTT.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Smarthome_MQTT.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='Smarthome Menü // INSTAR MQTT Broker' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Konfigurieren Sie den INSTAR MQTT-Broker - aktivieren Sie den Server oder wechseln Sie zu einem externen Broker. Sie können auch die Authentifizierung konfigurieren und Ihr persönliches SSL-Zertifikat hinzufügen.' image='/images/Search/WebUI_1440p_SearchThumb_Smarthome_MQTT.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Smarthome_MQTT.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Smarthome/MQTT/' locationFR='/fr/Web_User_Interface/1440p_Series/Smarthome/MQTT/' crumbLabel="MQTT Broker" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "smarthome-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#smarthome-men%C3%BC",
        "aria-label": "smarthome menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Smarthome Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/59b4cf3d812b45b4f59e19b81eee5358/8dd93/1440p_Settings_Smarthome_MQTT_Broker.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC0UlEQVQ4y2XT22/bZBzG8d7TChjLpLF0OThtYqermi1NWhJ1sZP6EDuNz06dpulgbBotuwBpaKAhhIbgEiEuYLtC4op/8oteZ112uHj0yDcf/96fX69sbW1Rr9ezKIpCrVZDkiR6s2dY3/5D76u/US9evp3zl/QvXhB8/y8NNaSQv87GZhXdMFipK8prTJblLLncVQ6jh8yf/E508Qvh+XOic9GXeZ7l9Olf3O4afLi2yidXriAVC6wob4BiOgGura1y0GlzMgkJXSeLN7JwHTNrzzFxRxbB8Rl3GttsSAWqlTw3rq0uQQEtwTW63S5JMuFkdsrnX9xnPj8jjCL8IMza8328IMJ1VO5NBwy0FoV87m1QlmsZmr+eY2gZHKcpcRyTJEnWY9dlNBph2zaWaWI7I1Lf5MTeQT9o4Bid9ycUz9VynqFpMJvNiKKIIAjwPC/DDMNgMBjQ72sY5pB4rONrdUb9BveO77474QKtVzfwjhzS6TQDBSZQ0zTpdDrs7++z127TUzUSV0dvFYjtBj/OtCV4iVarNVrNHaIwyI4pQF/s6xUahiGe5+K5brbPwd02bfkaTx8Y/HbfZiWb6I0dbtYUOvVPCYYq09mcNE1fIV7W4gVhlGQdJxP0XotuI8efzzyehJ0FKC734rgC3eSGZKHpc9LjiDhOXu9QgGLqOJ2TTCZEcYJn7XE0kHh80uVor7IAl/uTUeQN9oOfGSWPOZ3GRGGEK47n+ziOQ198EE1FU3tYpoWutujuSlSkdT7+6IMFeJlLVCoXONQPccMJo7GP7y/259hDBuoBqqbS1TQMe8ju7i6Fwk3K5RJF8acsoUUrco38zTKzox7//WDz6yObsevjjR2C+deE373gy7Nv+MOy+Wnsc6fZZH19nVKplOU9UK7VKJXK3FKqHDQVWjsKirgF4jZsN6jf/oztWw32ZJmmUqdSqVAsFjNM9P/IzupauusjNgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/59b4cf3d812b45b4f59e19b81eee5358/e4706/1440p_Settings_Smarthome_MQTT_Broker.avif 230w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/d1af7/1440p_Settings_Smarthome_MQTT_Broker.avif 460w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/7f308/1440p_Settings_Smarthome_MQTT_Broker.avif 920w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/19805/1440p_Settings_Smarthome_MQTT_Broker.avif 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/59b4cf3d812b45b4f59e19b81eee5358/a0b58/1440p_Settings_Smarthome_MQTT_Broker.webp 230w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/bc10c/1440p_Settings_Smarthome_MQTT_Broker.webp 460w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/966d8/1440p_Settings_Smarthome_MQTT_Broker.webp 920w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/61eb3/1440p_Settings_Smarthome_MQTT_Broker.webp 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/59b4cf3d812b45b4f59e19b81eee5358/81c8e/1440p_Settings_Smarthome_MQTT_Broker.png 230w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/08a84/1440p_Settings_Smarthome_MQTT_Broker.png 460w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/c0255/1440p_Settings_Smarthome_MQTT_Broker.png 920w", "/de/static/59b4cf3d812b45b4f59e19b81eee5358/8dd93/1440p_Settings_Smarthome_MQTT_Broker.png 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/59b4cf3d812b45b4f59e19b81eee5358/c0255/1440p_Settings_Smarthome_MQTT_Broker.png",
              "alt": "Web User Interface - 1440p Series - Smarthome MQTT",
              "title": "Web User Interface - 1440p Series - Smarthome MQTT",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <MqttTableBroker mdxType="MqttTableBroker" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/8dd93/1440p_Settings_Smarthome_MQTT_Client.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAACjElEQVQ4y43T20/TUBzAcd6FqJiRKINuK7AbiUxwbGxsA0p339qeXjY7LjNKooCJRE004oO3+KA++QRvPvhvfk07cSA+8PBN057kk3NOfh2Zn58nmUz6JRIJYrEYsixT2jqm9uInpf0T1g5OL7Z/ysbBCeLNL1JrJlLwNrNzUdRymZFkIvEXi8fjfoFAAMXcwz36ivn0I+b+WZ/O9YGtl9+5l1O5PjbKrfFx5JDESOIc6O3OA8fGRlldSdO1dUS7ht6ooDeraI0KWqPs166rCLvLYuous7JEdCbI5MToEPSgIThGPp/Hth0MYWLZDsK0sJ0OO7t9+v2HuG4PQ9hojTX6roKynkYKBi6C8XjMR4N3AtQqKp1OF1MIdF1HCEGz2URVVVR1E0XZQNlU6RoVeo0F1EKKRjl3eYfeezQyRbWs4vZ6OLaNaZo+WK3VyOXzZLMrZDMZisUSVlvF2EjS3EjR7xb/3eEATUZn0Vt1HrgujuNgGIYP1qoVVpaXyGTSLGYzZIslbG0TNR3Crqd4t7U+BM/QaDRGemkBYRg+5KXrBoauoVsu2vYhlrPDk3qDxy0dpbjMcnyC13tlvjyqM+Lv6NwdzsUS5JKTaOUCurD8+/NRrYVw97Cef2N794jP9SZvWwK1mCaXCvDjWOeVmRuA3nAPjuuhc0zKVUpKD1O00TTdR/3arcHItOpUDJ2aIdAqGVqKzLNenlZmZgAO7y9OIj7LinhPwz7ENjUsy8ayrD/Z/gh5T9s06TgdyuvL5O9HmJGnuHnj2gA86wyVZYl0epFCoeDP4+rq6qW87966d7pwSCISDhHy/pQhNHyGwxGmp6evlCRJhEIeFiYcDv8fjEQi/uLVC/l58G/0096oITB/lwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/190e69bd57c87b7b0646c8605e6ecbdf/e4706/1440p_Settings_Smarthome_MQTT_Client.avif 230w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/d1af7/1440p_Settings_Smarthome_MQTT_Client.avif 460w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/7f308/1440p_Settings_Smarthome_MQTT_Client.avif 920w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/19805/1440p_Settings_Smarthome_MQTT_Client.avif 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/190e69bd57c87b7b0646c8605e6ecbdf/a0b58/1440p_Settings_Smarthome_MQTT_Client.webp 230w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/bc10c/1440p_Settings_Smarthome_MQTT_Client.webp 460w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/966d8/1440p_Settings_Smarthome_MQTT_Client.webp 920w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/61eb3/1440p_Settings_Smarthome_MQTT_Client.webp 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/190e69bd57c87b7b0646c8605e6ecbdf/81c8e/1440p_Settings_Smarthome_MQTT_Client.png 230w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/08a84/1440p_Settings_Smarthome_MQTT_Client.png 460w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/c0255/1440p_Settings_Smarthome_MQTT_Client.png 920w", "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/8dd93/1440p_Settings_Smarthome_MQTT_Client.png 1369w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/190e69bd57c87b7b0646c8605e6ecbdf/c0255/1440p_Settings_Smarthome_MQTT_Client.png",
              "alt": "Web User Interface - 1440p Series - Smarthome MQTT",
              "title": "Web User Interface - 1440p Series - Smarthome MQTT",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <MqttTableClient mdxType="MqttTableClient" />
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox mdxType="DangerBox" />
    <h3 {...{
      "id": "wie-spricht-man-mqtt",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#wie-spricht-man-mqtt",
        "aria-label": "wie spricht man mqtt permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wie spricht man MQTT`}</h3>
    <p>{`Wenn Sie daran interessiert sind, Ihre Kamera über die MQTT-Schnittstelle zu einem Smarthome-System hinzuzufügen, sind Sie wahrscheinlich bereits mit unserer `}<a parentName="p" {...{
        "href": "/de/1440p_Serie_CGI_Befehle/"
      }}>{`HTTP/S CGI-Schnittstelle`}</a>{` vertraut, mit der Sie Befehle über Ihren Webbrowser an Ihre Kamera senden können.`}</p>
    <p>{`Mit MQTT funktioniert es sehr ähnlich. Jeder CGI-Befehl entspricht einem `}<a parentName="p" {...{
        "href": "/de/Erweitert/INSTAR_MQTT_Broker/"
      }}>{`MQTT-Topic`}</a>{` und jedes `}<strong parentName="p">{`Topic`}</strong>{` kann bestimmte `}<strong parentName="p">{`Payloads`}</strong>{` tragen. Um beispielsweise den ersten Bewegungserkennungsbereich Ihrer Kamera zu aktivieren, können Sie den folgenden CGI-Befehl senden:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`param.cgi?cmd`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`setmdattr`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span>{`-enable`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token variable"
          }}>{`\${val}`}</span></code></pre></div>
    <p>{`Dabei kann der Wert (`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`val`}</code>{`) `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0`}</code>{` oder `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`1`}</code>{` sein - je nachdem, ob Sie den Erkennungsbereich deaktivieren oder aktivieren möchten.`}</p>
    <p>{`In MQTT sieht das Gleiche wie folgt aus:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`alarm/area1/enable	`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"val"`}</span><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"0"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`, `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"val"`}</span><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"1"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Das Topic, um den Bereich ein- oder auszuschalten, ist `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`alarm/area1/enable`}</code>{` und Sie müssen entweder einen Wert von `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`1`}</code>{` oder `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`0`}</code>{` senden, um ihn zu schalten.`}</p>
    <p>{`Eine Übersicht über alle verfügbaren `}<a parentName="p" {...{
        "href": "/de/Erweitert/INSTAR_MQTT_Broker/MQTTv5_API/"
      }}>{`MQTT Topics und deren Payloads`}</a>{` finden Sie hier.`}</p>
    <h3 {...{
      "id": "syntax",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#syntax",
        "aria-label": "syntax permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Syntax`}</h3>
    <p>{`Um einen solchen Befehl zur Kamera zu senden, muß zuerst ein `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`instar/`}</code>{` vorangestellt werden. Um genau die richtige Kamera anzusprechen haben Sie jetzt 3 Möglichkeiten. Entweder Sie nutzen `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/local/`}</code>{` um die Kamera anzusprechen auf der der MQTT Broker läuft. Oder Sie bennen eine spezifischen Kamera anhand ihres MQTT Präfixes, dass Sie hier in der WebUI frei festlegen können - z.B. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mycamera`}</code>{`. Und als letztes haben Sie auch die Möglichkeit über `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/all/`}</code>{` gleich alle Kameras im MQTT Netz aufeinmal anzusprechen:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`instar/local/alarm/area1/enable`}</code></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`instar/mycamera/alarm/area1/enable`}</code></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`instar/all/alarm/area1/enable`}</code></li>
    </ul>
    <p>{`Nachdem sie ein solches Befehl Topic aktualisiert haben, wird Ihre Kamera ein Status Topic zurückgeben, um Ihnen zu sagen, dass alles funktioniert hat:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`instar/local/alarm/area1/enable`}</code>{` `}<strong parentName="li">{`Befehl Topic`}</strong></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`instar/local/status/alarm/area1/enable`}</code>{` `}<strong parentName="li">{`Status Topic`}</strong></li>
    </ul>
    <p>{`Mehr Informationen hierzu finden in unseren `}<a parentName="p" {...{
        "href": "/de/Erweitert/INSTAR_MQTT_Broker/"
      }}>{`MQTT Topics und Payloads Übersicht`}</a>{`.`}</p>
    <h3 {...{
      "id": "welche-software-kann-ich-verwenden",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#welche-software-kann-ich-verwenden",
        "aria-label": "welche software kann ich verwenden permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Welche Software kann ich verwenden?`}</h3>
    <p>{`Wir haben eine ständig wachsende `}<a parentName="p" {...{
        "href": "/de/Erweitert/INSTAR_MQTT_Broker/#software"
      }}>{`Liste von Software`}</a>{`, die mit dem MQTT-Protokoll kompatibel ist. Ein einfacher Einstieg sind Dashboard und Debugging Awendungen, die auf Ihrem Android-Telefon oder unter Windows oder macOS installiert werden können:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Android_Apps/"
        }}>{`Android Apps für MQTT`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Windows_macOS_und_LINUX_Apps/"
        }}>{`Windows und macOS Apps für MQTT`}</a></li>
    </ol>
    <p>{`Beide Android-Apps sind einfache Dashboards, mit denen Sie Ihre Kamera über die MQTT-Schnittstelle steuern können. Die Desktop-Apps können Sie verwenden, um die Verbindung zur Kamera zu testen, Interaktionen zwischen Ihrer Kamera und der Client-Anwendung aufzuzeichnen und Ihr MQTT-Netzwerk zu debuggen.`}</p>
    <p>{`Für kompatible `}<strong parentName="p">{`Smarthome Systeme`}</strong>{` lesen Sie bitte unsere Anleitungen :`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Home_Assistant/"
        }}>{`Home Assistant`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Node-RED/"
        }}>{`Node-RED`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/OpenHAB2/"
        }}>{`OpenHAB 2`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Athom_Homey_MQTT_Client/"
        }}>{`Athom Homey`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Homematic_CCU3_und_RedMatic/"
        }}>{`Homematic`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/Loxone/"
        }}>{`Loxone`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/homee/"
        }}>{`homee`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/ioBroker/"
        }}>{`IOBroker`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/de/Erweitert/INSTAR_MQTT_Broker/FHEM_House_Automation/"
        }}>{`FHEM`}</a></li>
    </ol>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_Testing/"
        }}>{`Testen des HTTP und MQTT Alarmservers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_MQTTv5_Autorefresh_Node-RED/"
        }}>{`Auto-Refreshing MQTT Topics in Node-RED`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_MQTTv5_Websocket_Client/"
        }}>{`INSTAR MQTTv5 Websocket Client`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_MQTT_System_Update/"
        }}>{`Trigger a System Update through the MQTT Interface`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Software/Other_Platforms/biOs_MQTT_Stream_Deck/"
        }}>{`Stream Deck biOs MQTT`}</a></li>
    </ul>
    <p>{`Lesen Sie unser FAQ, wenn Sie ein `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/INSTAR_MQTT_Self_Signed_SSL_Certificate/"
      }}>{`selbstsigniertes SSL-Zertifikat für den INSTAR MQTT-Broker verwenden möchten`}</a>{`.`}</p>
    <PrimaryBox mdxType="PrimaryBox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      